function projectFilter(button) {
  const category = button.dataset.category;
  const cards = document.querySelectorAll(".projects");
  const activeButton = document.querySelector(".active-filter");

  activeButton.classList.remove("bg-sky-500", "text-white", "active-filter");
  button.classList.add("bg-sky-500", "text-white", "active-filter");

  if (category === "Todos") {
    for (const card of cards) {
      card.classList.remove("hidden");
    }
    return;
  }

  for (const card of cards) {
    if (card.dataset.categories.toLowerCase().includes(category.toLowerCase())) {
      card.classList.remove("hidden");
    } else {
      card.classList.add("hidden");
    }
  }
}

document.querySelectorAll(".project-filter-btn").forEach((btn) => {
  btn.addEventListener("click", () => projectFilter(btn));
});
